import withProps from 'recompose/withProps';
import { FormattedMessage } from 'react-intl';

export default withProps({
  id: 'terminal-page.title-short',
  defaultMessage: 'Terminal',
})(FormattedMessage);
